import classNames from 'classnames';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { IChoiceQuestionProp, IListItemOption } from '@/utils/ctype';
import Radio from '../../../components/Radio';
import Analysis from '../../../components/Analysis';
import SpeechBtn from '../../../components/SpeechBtn';
import HtmlParser from '../../../components/HtmlParser';
import style from './index.module.less';

/**
 * 选择题
 * @param props 
 * @returns 
 */
export default function choiceQuestion(props: IChoiceQuestionProp & {index: number;isJudge?: boolean; className?: string;}) {
  const { data, groupId, currentFocus, saveAnswerHandle, type, answerMap, isAI, className, isJudge = false, isListen, keyIndex, index: itemIndex, answerAllText, setFocusIndexHandle} = props;
  const { title, number} = data;
  const {id} = data;
  const answerData = answerMap[`${groupId}_${type}_${id}`];
  const createAIType = (idStr: string, option: IListItemOption) => {
    if (!isAI) {
      return null;
    }
    // display_answer 为ABC 我拿到的answerData
    if (option?.title === data?.display_answer || (isJudge && option?.content === data?.display_answer)) {
      return 'success';
    } else if (idStr === (answerData && answerData[0])) {
      return 'fail';
    } else {
      return 'normal';
    }
  };
  

  return (
    <div className={classNames(`${style.questionBox}`, currentFocus === number ? style.active : '', className, `question${number}`, 'choiceQuestion')} id={`question${number}`}>
      <div className={style.questionContent} >
        <span className={classNames(style.questionNumber, currentFocus === number ? style.focus : '')} data-key={`$question.question.${keyIndex}.list.${itemIndex}.number`}><HtmlParser htmlString={data.numberHtml || String(number)}></HtmlParser></span>
        <span className={style.questionText} data-key={`question.question.${keyIndex}.list.${itemIndex}.title`}><HtmlParser htmlString={title}></HtmlParser></span>
        {isAI && !(answerData && answerData[0]) ? <span className={style.answerText} data-key={`answerAllText.${number-1}`}><HtmlParser htmlString={answerAllText[number - 1]}></HtmlParser></span> : null }
        {isAI && isListen ? <SpeechBtn onClick={() => {playAudio(data);}} index={number}></SpeechBtn> : null}
        {isAI ? <Analysis onClick={() => {parsingAI(data);}}></Analysis> : null}
      </div>
      {
        !!data.img_url ? <img style={{ width: '100%' }} src={data.img_url} /> : null
      }
      <div className={style.answerBox}>
        {data.option.map((item, index: number) => {
          const idStr = String(item.id);
          const radioType = createAIType(idStr, item);
          return (
            <div className={classNames(style.answer, radioType ? style[radioType]: '')} key={index}>
              <label data-key={`$question.question.${keyIndex}.list.${itemIndex}.option.${index}.content`}>
                <Radio type={radioType} className={style.radio} name={`anwer${number}`} checked={answerData && answerData[0] === idStr} onChange={() => {saveAnswerHandle(number, {group_id: groupId, id: data.id, type: type, answer: [idStr] });}} 
                  onFocus={() => { if (setFocusIndexHandle) {setFocusIndexHandle(number);}}}/>
                <HtmlParser htmlString={item.contentHtml || item.content}></HtmlParser>
              </label>
            </div>
          ); 
        })}
      </div>
    </div>
  );
}